module.exports = "https://de18y2hs3hlxs.cloudfront.net/55a5b72b-ea57-45f3-9ae4-45ca394141b9/images/notepad-2.png?93936d7ca0aada75a2e9c11d9bd6e63d";